import React from 'react';
import { Clock, Sparkles, Leaf, Camera } from 'lucide-react';
import { advantages } from '../../data/mock';

const iconMap = {
  Clock,
  Sparkles,
  Leaf,
  Camera
};

const GuaranteeSection = () => {
  return (
    <section className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Content */}
          <div>
            <div className="inline-flex items-center bg-blue-50 text-blue-700 px-4 py-2 rounded-full text-sm font-medium mb-6">
              Nos garanties
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6">
              Pourquoi choisir
              <span className="text-blue-600"> nos services ?</span>
            </h2>
            <p className="text-slate-600 mb-10 text-lg leading-relaxed">
              Grâce à notre caméra intégrée et notre technologie de pointe, nous assurons un nettoyage efficace garantissant jusqu'à 95% de propreté sur la coque.
            </p>

            <div className="space-y-6">
              {advantages.map((advantage) => {
                const IconComponent = iconMap[advantage.icon];
                return (
                  <div
                    key={advantage.id}
                    className="flex items-start gap-4 bg-white p-5 rounded-xl shadow-sm hover:shadow-md transition-shadow"
                  >
                    <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-blue-700 rounded-xl flex items-center justify-center flex-shrink-0 shadow-lg">
                      <IconComponent className="w-6 h-6 text-white" />
                    </div>
                    <div>
                      <h3 className="font-semibold text-slate-800 mb-1">{advantage.title}</h3>
                      <p className="text-slate-600 text-sm">{advantage.description}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Gallery */}
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-4">
              <div className="rounded-2xl overflow-hidden shadow-lg">
                <img
                  src="https://customer-assets.emergentagent.com/job_e5574598-9882-4c0d-a82a-daa0265bfbb4/artifacts/t3vlwtn7_IMG-20260103-WA0004.jpg"
                  alt="Nettoyage de coque"
                  className="w-full h-64 object-cover hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="rounded-2xl overflow-hidden shadow-lg">
                <img
                  src="https://customer-assets.emergentagent.com/job_e5574598-9882-4c0d-a82a-daa0265bfbb4/artifacts/7ec7de9u_IMG-20260103-WA0001.jpg"
                  alt="Drone Keelcrab"
                  className="w-full h-48 object-cover hover:scale-105 transition-transform duration-500"
                />
              </div>
            </div>
            <div className="space-y-4 pt-8">
              <div className="rounded-2xl overflow-hidden shadow-lg">
                <img
                  src="https://customer-assets.emergentagent.com/job_e5574598-9882-4c0d-a82a-daa0265bfbb4/artifacts/t3nmtwgl_IMG-20260103-WA0002.jpg"
                  alt="Intervention sur bateau"
                  className="w-full h-48 object-cover hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="rounded-2xl overflow-hidden shadow-lg">
                <img
                  src="https://customer-assets.emergentagent.com/job_e5574598-9882-4c0d-a82a-daa0265bfbb4/artifacts/wqlk1701_IMG-20260103-WA0003.jpg"
                  alt="Service de nettoyage"
                  className="w-full h-64 object-cover hover:scale-105 transition-transform duration-500"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GuaranteeSection;
